import { z } from 'zod';
export const emailSchema = z
    .string()
    .email('Ógilt netfang')
    .max(255)
    .transform((v) => v.toLowerCase().trim());
export const passwordSchema = z
    .string()
    .min(8, 'Lykilorð verður að vera a.m.k. 8 stafir')
    .max(128)
    .regex(/[A-Z]/, 'Lykilorð verður að innihalda stóran staf')
    .regex(/[a-z]/, 'Lykilorð verður að innihalda lítinn staf')
    .regex(/[0-9]/, 'Lykilorð verður að innihalda tölu');
export const kennitalaSchema = z
    .string()
    .regex(/^\d{10}$/, 'Kennitala verður að vera 10 tölustafir')
    .refine(isValidKennitala, 'Ógild kennitala');
export const fullNameSchema = z
    .string()
    .min(2, 'Nafn verður að vera a.m.k. 2 stafir')
    .max(255)
    .trim();
export const phoneSchema = z
    .string()
    .regex(/^\+?[\d\s-]{7,20}$/, 'Ógilt símanúmer')
    .optional();
// Cast to ZodType<T> to fix TypeScript inference issues with ZodEffects fields
// (emailSchema uses .transform(), fullNameSchema uses .trim()) in some TS+Zod versions.
export const registerSchema = z.object({
    email: emailSchema,
    password: passwordSchema,
    fullName: fullNameSchema,
    kennitala: kennitalaSchema.optional(),
    phone: phoneSchema,
});
export const loginSchema = z.object({
    email: emailSchema,
    password: z.string().min(1),
});
export const purchasePassSchema = z.object({
    passType: z.enum(['single', 'ten_pack', 'monthly', 'annual']),
    poolId: z.string().uuid().optional(),
    idempotencyKey: z.string().uuid(),
});
export const paginationSchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    perPage: z.coerce.number().int().min(1).max(100).default(20),
});
export const waitlistEmailSchema = z.object({
    email: emailSchema,
    turnstileToken: z.string().min(1, 'Captcha token is required'),
});
export const supporterSchema = z.object({
    name: z.string().max(255).optional(),
    anonymous: z.boolean(),
    turnstileToken: z.string().min(1, 'Captcha token is required'),
});
function isValidKennitala(kt) {
    if (!/^\d{10}$/.test(kt))
        return false;
    const weights = [3, 2, 7, 6, 5, 4, 3, 2];
    const digits = kt.split('').map(Number);
    const sum = weights.reduce((acc, w, i) => acc + w * digits[i], 0);
    const remainder = sum % 11;
    const check = remainder === 0 ? 0 : 11 - remainder;
    if (check === 10)
        return false;
    return check === digits[8];
}
//# sourceMappingURL=schemas.js.map